var render, staticRenderFns
import script from "./sectionHeader.vue?vue&type=script&lang=js&"
export * from "./sectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./sectionHeader.vue?vue&type=style&index=0&id=6b50b156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b50b156",
  null
  
)

export default component.exports